const measures = {
  time: { id: "time", name: "Time" },
  length: { id: "length", name: "Length" },
  mass: { id: "mass", name: "Mass" },
  currency: { id: "currency", name: "currency" },
  volume: { id: "volume", name: "volume" },
};
export default measures;
